(function (app, ng) {
    undoToastController.$inject = ["message", "overlay", "$mdToast", "figOverlay"];

    function undoToastController(message, overlay, $mdToast, figOverlay) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            undo: undo,
            message: message
        });

        function undo() {
            if (overlay) figOverlay.end();
            $mdToast.hide(false);
        }
    }

    simpleToastController.$inject = ["message", "$mdToast"];

    function simpleToastController(message, $mdToast) {
        var $ctrl = this;

        $ctrl.message = message;
        $ctrl.close = () => {
            $mdToast.hide(false);
        }
    }

    yesNoToastController.$inject = ["message", "overlay", "$mdToast", "figOverlay"];

    function yesNoToastController(message, overlay, $mdToast, figOverlay) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            yes: yes,
            no: no,
            message: message
            });

        //$mdToast.hide() resolves the promises, which can be chained in the parent controller
        function yes() {
            if (overlay) figOverlay.end();
            $mdToast.hide(true);
        }

        //$mdToast.cancel() rejects the promises, which can be caught in the parent controller
        function no() {
            if (overlay) figOverlay.end();
            $mdToast.cancel(false);
        }
    }

    errorToastController.$inject = ["message", "overlay", "$mdToast", "figOverlay"];

    function errorToastController(message, overlay, $mdToast, figOverlay) {
        var $ctrl = this;

        ng.extend($ctrl,
        {
            message: message,
            close: close
        });

        function close() {
            if (overlay) figOverlay.end();

            $mdToast.hide();
        }
    }

    app.provider("figToaster", [function () {
        this.$get = ["$mdToast", "figOverlay", function ($mdToast, figOverlay) {
            var service = {};

            service.showUndo = function (message, position, parent, overlay) {
                if (overlay) figOverlay.start();

                var options = {
                    templateUrl: "/App/Services/Toaster/undo.html",
                    position: position,
                    controller: undoToastController,
                    controllerAs: "$ctrl",
                    locals: {
                        message: message,
                        overlay: overlay
                    },
                    bindToController: true,
                    hideDelay: 5000
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            service.showYesNo = function (message, position, parent, overlay) {
                if (overlay) figOverlay.start();

                var options = {
                    templateUrl: "/App/Services/Toaster/yesno.html",
                    position: position,
                    controller: yesNoToastController,
                    controllerAs: "$ctrl",
                    locals: {
                        message: message,
                        overlay: overlay
                    },
                    bindToController: true,
                    hideDelay: 0
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            service.showSimple = function (message, position, parent) {
                var options = {
                    templateUrl: "/App/Services/Toaster/simple.html",
                    position: position,
                    controller: simpleToastController,
                    controllerAs: "$ctrl",
                    locals: { message: message },
                    bindToController: true,
                    hideDelay: 3200
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            service.showError = function (message, position, parent, overlay) {
                if (overlay) figOverlay.start();

                var options = {
                    templateUrl: "/App/Services/Toaster/error.html",
                    position: position,
                    controller: errorToastController,
                    controllerAs: "$ctrl",
                    locals: {
                        message: message,
                        overlay: overlay
                    },
                    bindToController: true,
                    hideDelay: 0
                };

                if (parent)
                    options.parent = parent;

                return $mdToast.show(options);
            };

            return service;
        }];
    }]);

    app.directive("figToastContainer", ["figToastContainers", function (figToastContainers) {
        return {
            scope: {
                figToastContainer: "@"
            },
            restrict: "A",
            link: function (scope, elem) {
                elem[0].style.position = "relative";

                elem.on("$destroy", figToastContainers.register(scope.figToastContainer, elem));
            }
        }
    }]);

    app.provider("figToastContainers", [function () {
        this.$get = ["_", function (_) {
            var service = {};
            var containers = [];

            service.register = function (key, elem) {
                var obj = {
                    key: key,
                    elem: elem
                };

                containers.push(obj);

                return function() {
                    containers.splice(containers.indexOf(obj), 1);
                };
            };

            service.get = function (key) {
                return _.find(containers, { key: key }).elem;
            };

            return service;
        }];
    }]);
})(window.app, window.angular); // jshint ignore:line